<template>
  <b-modal
    :visible="show"
    title="Históricos salvos"
    centered
    hide-footer
    size="lg"
    @hidden="$emit('update:show', false)"
  >
    <!-- LOADING -->
    <div
      v-if="loading"
      class="d-flex justify-content-center align-items-center"
      style="height: 200px"
    >
      <b-spinner variant="primary" label="Carregando..."></b-spinner>
    </div>

    <!-- CONTEÚDO -->
    <div v-else>
      <div v-if="!items.length" class="alert alert-info mb-0">
        Nenhum histórico encontrado.
      </div>

      <div v-else class="list-group">
        <button
          v-for="(item, index) in items"
          :key="buildKey(item, index)"
          type="button"
          class="list-group-item list-group-item-action"
          @click="selecionar(item)"
        >
          <div>
            <strong>Período:</strong>
            {{ formatDate(item.dt_inicial) }} a {{ formatDate(item.dt_final) }}
          </div>
          <div><strong>Tipo:</strong> {{ item.rel_tipo }}</div>
          <div>
            <strong>Atualizado por:</strong> {{ item.quem_atualizou || '-' }}
          </div>
          <div>
            <strong>Data do registro:</strong>
            {{ formatDateTime(item.created_at) }}
          </div>
        </button>
      </div>
    </div>
  </b-modal>
</template>

<script>
import utils from '@/mixins/utils.js'

export default {
  name: 'ModalHistoricoMicroArea',
  mixins: [utils],
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    items: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    selecionar(item) {
      this.$emit('selecionar', item)
    },

    buildKey(item, index) {
      return `${item.rel_tipo || 'tipo'}-${item.dt_inicial || 'ini'}-${
        item.dt_final || 'fim'
      }-${index}`
    },

    formatDateTime(value) {
      if (!value) return '-'

      const data = new Date(value)

      if (Number.isNaN(data.getTime())) {
        return value
      }

      const dia = String(data.getDate()).padStart(2, '0')
      const mes = String(data.getMonth() + 1).padStart(2, '0')
      const ano = data.getFullYear()
      const hora = String(data.getHours()).padStart(2, '0')
      const minuto = String(data.getMinutes()).padStart(2, '0')

      return `${dia}/${mes}/${ano} ${hora}:${minuto}`
    },
  },
}
</script>
